export default "__VITE_ASSET__7OpFgPXO__"